<template>
    <div class="form__section">
        <div class="row">
            <div class="col-12">
                <div class="form-section__header">
                    <h2 class="title title--3">{{ formLabels.title }}</h2>
                    <p v-if="formLabels.description">{{ formLabels.description }}</p>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="form-group form-group--checkbox-row">
                    <div class="form-field form-field--checkbox">
                        <input v-model="formData.benefit.action" :value="formLabels.fields.benefitAction1" id="benefitAction1" type="radio" />
                        <label for="benefitAction1">{{ formLabels.fields.benefitAction1 }}</label>
                    </div>
                    <div class="form-field form-field--checkbox">
                        <input v-model="formData.benefit.action" :value="formLabels.fields.benefitAction2" id="benefitAction2" type="radio" />
                        <label for="benefitAction2">{{ formLabels.fields.benefitAction2 }}</label>
                    </div>
                    <div class="form-field form-field--checkbox">
                        <input v-model="formData.benefit.action" :value="formLabels.fields.benefitAction3" id="benefitAction3" type="radio" />
                        <label for="benefitAction3">{{ formLabels.fields.benefitAction3 }}</label>
                    </div>
                    <span class="form-group__error" v-if="$v.formData.benefit.action.$error">Please select an option</span>
                </div>
            </div>
        </div>
        <div class="row" v-if="formData.benefit.action && formData.benefit.action !== formLabels.fields.benefitAction3">
            <div class="col-12">
                <h3>Select your membership type</h3>
            </div>
            <div class="col-12">
                <div class="form-group form-group--checkbox-row">
                    <div class="form-field form-field--checkbox">
                        <input v-model="formData.benefit.type" :value="formLabels.fields.benefitType1" id="benefitType1" type="radio" />
                        <label for="benefitType1">{{ formLabels.fields.benefitType1 }}</label>
                    </div>
                    <div class="form-field form-field--checkbox">
                        <input v-model="formData.benefit.type" :value="formLabels.fields.benefitType2" id="benefitType2" type="radio" />
                        <label for="benefitType2">{{ formLabels.fields.benefitType2 }}</label>
                    </div>
                    <div class="form-field form-field--checkbox">
                        <input v-model="formData.benefit.type" :value="formLabels.fields.benefitType3" id="benefitType3" type="radio" />
                        <label for="benefitType3">{{ formLabels.fields.benefitType3 }}</label>
                    </div>
                    <div class="form-field form-field--checkbox">
                        <input v-model="formData.benefit.type" :value="formLabels.fields.benefitType4" id="benefitType4" type="radio" />
                        <label for="benefitType4">{{ formLabels.fields.benefitType4 }}</label>
                    </div>
                    <div class="form-field form-field--checkbox">
                        <input v-model="formData.benefit.type" :value="formLabels.fields.benefitType5" id="benefitType5" type="radio" />
                        <label for="benefitType5">{{ formLabels.fields.benefitType5 }}</label>
                    </div>
                    <div class="form-field form-field--checkbox">
                        <input v-model="formData.benefit.type" :value="formLabels.fields.benefitType6" id="benefitType6" type="radio" />
                        <label for="benefitType6">{{ formLabels.fields.benefitType6 }}</label>
                    </div>
                    <div class="form-field form-field--checkbox">
                        <input v-model="formData.benefit.type" :value="formLabels.fields.benefitType7" id="benefitType7" type="radio" />
                        <label for="benefitType7">{{ formLabels.fields.benefitType7 }}</label>
                    </div>
                    <div class="form-field form-field--checkbox">
                        <input v-model="formData.benefit.type" :value="formLabels.fields.benefitType8" id="benefitType8" type="radio" />
                        <label for="benefitType8">{{ formLabels.fields.benefitType8 }}</label>
                    </div>
                    <span class="form-group__error" v-if="$v.formData.benefit.type.$error">Please select an option</span>
                </div>
            </div>
        </div>
        <div class="row row--margin-top" v-if="formData.benefit.action == formLabels.fields.benefitAction2 && formData.benefit.type">
            <div class="col-12">
                <h3>{{ formLabels.fields.amendmentDetails }}</h3>
            </div>
            <div class="col-12">
                <div class="form-group form-group--checkbox-row">
                    <div class="form-field form-field--checkbox"  v-if="formData.benefit.type != formLabels.fields.benefitType1 && formData.benefit.type != formLabels.fields.benefitType5">
                        <input v-model="formData.benefit.amendAction" value="Add family members" id="benefitTypeAddFamily" type="radio" />
                        <label for="benefitTypeAddFamily">I want to add family member(s)</label>
                    </div>
                    <div class="form-field form-field--checkbox" v-if="formData.benefit.type === formLabels.fields.benefitType1 || formData.benefit.type === formLabels.fields.benefitType5">
                        <input v-model="formData.benefit.amendAction" value="Keep current family members" id="keepCurrentFamily" type="radio" />
                        <label for="keepCurrentFamily">I do not need to remove family member(s)</label>
                    </div>
                    <div class="form-field form-field--checkbox">
                        <input v-model="formData.benefit.amendAction" value="Remove family members" id="benefitTypeRemoveFamily" type="radio" />
                        <label for="benefitTypeRemoveFamily">I want to remove family member(s)</label>
                    </div>
                    <span class="form-group__error" v-if="$v.formData.benefit.amendAction.$error">Please select an option</span>
                </div>
            </div>
        </div>
        <div class="row row--margin-top" v-if="showPartnerFields">
            <div class="col-12">
                <div class="row">
                    <div class="col-12">
                        <h3>Your spouse/partner's details</h3>
                    </div>
                    <div class="col-12 col-lg-6">
                        <div :class="['form-field',{'form-field--error':$v.formData.familyMembers.$each[0].firstName.$error}]">
                            <label for="forename1">{{ formLabels.personFields.firstName }}</label>
                            <input v-model="formData.familyMembers[0].firstName" id="forename1" type="text" />
                            <span class="form-field__tooltip" v-if="formTooltips && formTooltips.personFields && formTooltips.personFields.fields.firstName" v-tooltip="formTooltips.personFields.fields.firstName">?</span>
                            <span class="form-field__error" v-if="$v.formData.familyMembers.$each[0].firstName.$error">This field is required</span>
                        </div>
                    </div>
                    <div class="col-12 col-lg-6">
                        <div :class="['form-field',{'form-field--error':$v.formData.familyMembers.$each[0].lastName.$error}]">
                            <label for="lastName1">{{ formLabels.personFields.lastName }}</label>
                            <input v-model="formData.familyMembers[0].lastName" id="lastName1" type="text" />
                            <span class="form-field__tooltip" v-if="formTooltips && formTooltips.personFields && formTooltips.personFields.fields.lastName" v-tooltip="formTooltips.personFields.fields.lastName">?</span>
                            <span class="form-field__error" v-if="$v.formData.familyMembers.$each[0].lastName.$error">This field is required</span>
                        </div>
                    </div>
                    <div class="col-12 col-lg-6">
                        <div :class="['form-field',{'form-field--error':$v.formData.familyMembers.$each[0].dob.$error}]">
                            <label for="dob1">{{ formLabels.personFields.dob }}</label>
                            <date-picker v-model="formData.familyMembers[0].dob" id="dob1" format="DD/MM/YYYY" value-type="format"></date-picker>
                            <span class="form-field__tooltip" v-if="formTooltips && formTooltips.personFields && formTooltips.personFields.fields.dob" v-tooltip="formTooltips.personFields.fields.dob">?</span>
                            <span class="form-field__error" v-if="$v.formData.familyMembers.$each[0].dob.$error">This field is required</span>
                        </div>
                    </div>
                    <div class="col-12 col-lg-6">
                        <div :class="['form-field form-field--dropdown', {'form-field--error':$v.formData.familyMembers.$each[0].gender.$error}]">
                            <label for="gender1">{{ formLabels.personFields.gender }}</label>
                            <select v-model="formData.familyMembers[0].gender">
                                <option :value="null || undefined" disabled>Please select</option>
                                <option value="Male">Male</option>
                                <option value="Female">Female</option>
                            </select>
                            <span v-if="formTooltips.sexToolTip" class="form-field__tooltip" v-tooltip="formTooltips.sexToolTip">?</span>
                            <span class="form-field__error" v-if="$v.formData.familyMembers.$each[0].gender.$error">This field is required</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row row--margin-top" v-if="showFamilyFields">
            <div class="col-12">
                <div class="row">
                    <div class="col-12">
                        <h3 v-if="formData.benefit.amendAction && formData.benefit.amendAction === 'Remove family members'">Remove a family member</h3>
                        <h3 v-else-if="formData.benefit.amendAction || formData.benefit.type === formLabels.fields.benefitType3">Add a family member</h3>
                        <h3 v-else-if="formData.benefit.type === formLabels.fields.benefitType4">Add a child</h3>
                    </div>
                    <div class="col-12 col-lg-6">
                        <div :class="['form-field',{'form-field--error':$v.formData.familyMembers.$each[0].firstName.$error}]">
                            <label for="forename1">{{ formLabels.personFields.firstName }}</label>
                            <input v-model="formData.familyMembers[0].firstName" id="forename1" type="text" />
                            <span class="form-field__tooltip" v-if="formTooltips && formTooltips.personFields && formTooltips.personFields.fields.firstName" v-tooltip="formTooltips.personFields.fields.firstName">?</span>
                            <span class="form-field__error" v-if="$v.formData.familyMembers.$each[0].firstName.$error">This field is required</span>
                        </div>
                    </div>
                    <div class="col-12 col-lg-6">
                        <div :class="['form-field',{'form-field--error':$v.formData.familyMembers.$each[0].lastName.$error}]">
                            <label for="lastName1">{{ formLabels.personFields.lastName }}</label>
                            <input v-model="formData.familyMembers[0].lastName" id="lastName1" type="text" />
                            <span class="form-field__tooltip" v-if="formTooltips && formTooltips.personFields && formTooltips.personFields.fields.lastName" v-tooltip="formTooltips.personFields.fields.lastName">?</span>
                            <span class="form-field__error" v-if="$v.formData.familyMembers.$each[0].lastName.$error">This field is required</span>
                        </div>
                    </div>
                    <div class="col-12 col-lg-6">
                        <div :class="['form-field',{'form-field--error':$v.formData.familyMembers.$each[0].dob.$error}]">
                            <label for="dob1">{{ formLabels.personFields.dob }}</label>
                            <date-picker v-model="formData.familyMembers[0].dob" id="dob1" format="DD/MM/YYYY" value-type="format"></date-picker>
                            <span class="form-field__tooltip" v-if="formTooltips && formTooltips.personFields && formTooltips.personFields.fields.dob" v-tooltip="formTooltips.personFields.fields.dob">?</span>
                            <span class="form-field__error" v-if="$v.formData.familyMembers.$each[0].dob.$error">This field is required</span>
                        </div>
                    </div>
                    <div class="col-12 col-lg-6">
                        <div :class="['form-field form-field--dropdown', {'form-field--error':$v.formData.familyMembers.$each[0].gender.$error}]">
                            <label for="gender1">{{ formLabels.personFields.gender }}</label>
                            <select v-model="formData.familyMembers[0].gender">
                                <option :value="null || undefined" disabled>Please select</option>
                                <option value="Male">Male</option>
                                <option value="Female">Female</option>
                            </select>
                            <span v-if="formTooltips.sexToolTip" class="form-field__tooltip" v-tooltip="formTooltips.sexToolTip">?</span>
                            <span class="form-field__error" v-if="$v.formData.familyMembers.$each[0].gender.$error">This field is required</span>
                        </div>
                    </div>
                    <div v-if="formData.benefit.type !== formLabels.fields.benefitType4" class="col-12 col-lg-6">
                        <div :class="['form-field',{'form-field--error':$v.formData.familyMembers.$each[0].relationship.$error}]">
                            <label for="relationship1">{{ formLabels.personFields.relationship }}</label>
                            <select v-model="formData.familyMembers[0].relationship">
                                <option :value="null || undefined" disabled>Please select</option>
                                <option value="Spouse/Partner">Spouse/Partner</option>
                                <option value="Child">Child</option>
                            </select>
                            <span class="form-field__tooltip" v-if="formTooltips && formTooltips.personFields && formTooltips.personFields.fields.relationship" v-tooltip="formTooltips.personFields.fields.relationship">?</span>
                            <span class="form-field__error" v-if="$v.formData.familyMembers.$each[0].relationship.$error">This field is required</span>
                        </div>
                    </div>
                    <div class="col-12" v-if="formData.familyMembers.length === 1">
                        <a href="#" @click.prevent="addFamilyMember" class="button button--secondary">{{ addFamilyButtonText }}</a>
                    </div>
                </div>
                <div class="row row--margin-top" v-for="i in (formData.familyMembers.length - 1)" :key="i">
                    <div class="col-12 ">
                        <h3 v-if="formData.benefit.amendAction && formData.benefit.amendAction === 'Remove family members'">Remove family member {{i + 1}} <a href="#" @click.prevent="removeFamilyMember(i + 1)" class="family-member-remove">(Delete)</a></h3>
                        <h3 v-else-if="formData.benefit.amendAction || formData.benefit.type === formLabels.fields.benefitType3">Add family member {{i + 1}} <a href="#" @click.prevent="removeFamilyMember(i + 1)" class="family-member-remove">(Remove)</a></h3>
                        <h3 v-else-if="formData.benefit.type === formLabels.fields.benefitType4">Add child {{i + 1}} <a href="#" @click.prevent="removeFamilyMember(i + 1)" class="family-member-remove">(Remove)</a></h3>
                    </div>
                    <div class="col-12 col-lg-6">
                        <div :class="['form-field',{'form-field--error':$v.formData.familyMembers.$each[i].firstName.$error}]">
                            <label :for="`firstName${i + 1}`">{{ formLabels.personFields.firstName }}</label>
                            <input v-model="formData.familyMembers[i].firstName" :id="`firstName${i + 1}`" type="text" />
                            <span class="form-field__tooltip" v-if="formTooltips && formTooltips.personFields && formTooltips.personFields.fields.firstName" v-tooltip="formTooltips.personFields.fields.firstName">?</span>
                            <span class="form-field__error" v-if="$v.formData.familyMembers.$each[i].firstName.$error">This field is required</span>
                        </div>
                    </div>
                    <div class="col-12 col-lg-6">
                        <div :class="['form-field',{'form-field--error':$v.formData.familyMembers.$each[i].lastName.$error}]">
                            <label :for="`lastName${i + 1}`">{{ formLabels.personFields.lastName }}</label>
                            <input v-model="formData.familyMembers[i].lastName" :id="`lastName${i + 1}`" type="text" />
                            <span class="form-field__tooltip" v-if="formTooltips && formTooltips.personFields && formTooltips.personFields.fields.lastName" v-tooltip="formTooltips.personFields.fields.lastName">?</span>
                            <span class="form-field__error" v-if="$v.formData.familyMembers.$each[i].lastName.$error">This field is required</span>
                        </div>
                    </div>
                    <div class="col-12 col-lg-6">
                        <div :class="['form-field',{'form-field--error':$v.formData.familyMembers.$each[i].dob.$error}]">
                            <label :for="`dob${i + 1}`">{{ formLabels.personFields.dob }}</label>
                            <date-picker v-model="formData.familyMembers[i].dob" :id="`dob${i + 1}`" format="DD/MM/YYYY" value-type="format"></date-picker>
                            <span class="form-field__tooltip" v-if="formTooltips && formTooltips.personFields && formTooltips.personFields.fields.dob" v-tooltip="formTooltips.personFields.fields.dob">?</span>
                            <span class="form-field__error" v-if="$v.formData.familyMembers.$each[i].dob.$error">This field is required</span>
                        </div>
                    </div>
                    <div class="col-12 col-lg-6">
                        <div :class="['form-field',{'form-field--error':$v.formData.familyMembers.$each[i].gender.$error}]">
                            <label :for="`gender${i + 1}`">{{ formLabels.personFields.gender }}</label>
                            <select v-model="formData.familyMembers[i].gender" :id="`gender${i + 1}`">
                                <option :value="null || undefined" disabled>Please select</option>
                                <option value="Male">Male</option>
                                <option value="Female">Female</option>
                            </select>
                            <span v-if="formTooltips.sexToolTip" class="form-field__tooltip" v-tooltip="formTooltips.sexToolTip">?</span>
                            <span class="form-field__error" v-if="$v.formData.familyMembers.$each[i].gender.$error">This field is required</span>
                        </div>
                    </div>
                    <div v-if="formData.benefit.type !== formLabels.fields.benefitType4" class="col-12 col-lg-6">
                        <div :class="['form-field',{'form-field--error':$v.formData.familyMembers.$each[i].relationship.$error}]">
                            <label :for="`relationship${i + 1}`">{{ formLabels.personFields.relationship }}</label>
                            <select v-model="formData.familyMembers[i].relationship" :id="`relationship${i + 1}`">
                                <option :value="null || undefined" disabled>Please select</option>
                                <option value="Spouse/Partner">Spouse/Partner</option>
                                <option value="Child">Child</option>
                            </select>
                            <span class="form-field__tooltip" v-if="formTooltips && formTooltips.personFields && formTooltips.personFields.fields.relationship" v-tooltip="formTooltips.personFields.fields.relationship">?</span>
                            <span class="form-field__error" v-if="$v.formData.familyMembers.$each[i].relationship.$error">This field is required</span>
                        </div>
                    </div>
                    <div class="col-12" v-if="formData.familyMembers.length === (i + 1) && formData.familyMembers.length < maxFamilyMembers">
                        <a href="#" @click.prevent="addFamilyMember" class="button button--secondary">{{ addFamilyButtonText }}</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
import DatePicker from 'vue2-datepicker';

export default {
    data: () => ({
        maxFamilyMembers: 6
    }),
    props: {
        formLabels: {
            type: Object,
            required: true
        },
        formTooltips: {
            type: Object
        }
    },
    components: { DatePicker },
    inject: ['$v'],
    watch: {
        'formData.benefit.action': {
            handler: function(newVal) {
                
                if(this.formData.benefit.type) {
                    this.formData.benefit.type = undefined;
                    this.formSummary[1].fields['Cover type'] = undefined;
                }

                if(this.formData.benefit.amendAction && newVal !== this.formLabels.fields.benefitAction2) {
                    this.formData.benefit.amendAction = '';
                }

                this.formData.familyMembers = [{}];
                this.formSummary[1].fields = {
                    'Family members': [{}]
                }
            }
        },
        'formData.benefit.type': {
            handler: function(newVal) {

                this.formData.familyMembers = [{}];

                if(newVal === this.formLabels.fields.benefitType2) {
                    this.formData.familyMembers[0].relationship = 'Spouse/Partner';
                }

                if(newVal === this.formLabels.fields.benefitType4) {
                    this.formData.familyMembers[0].relationship = 'Child';
                }
                
                // Reset other form values on add family change
                this.formSummary[1].fields = {
                    'Family members': [{}]
                }
            }
        },
        'formData.benefit': {
            handler: function(newVal) {
                this.buildSummary(newVal);
            },
            deep: true
        },
        'formData.familyMembers': {
            handler: function(newVal) {
                this.buildSummary(newVal);
            },
            deep: true
        }
    },
    computed: {
        ...mapGetters(['formData','formSummary']),
        formConditionals: {
            get() {
                return this.$store.state.formConditionals;
            }, 
            set(value) {
                this.$store.commit('updateFormConditionals',value);
            }
        },
        showFamilyFields() {
            return (this.formData.benefit.type === this.formLabels.fields.benefitType3 || this.formData.benefit.type === this.formLabels.fields.benefitType4 
                || this.formData.benefit.type === this.formLabels.fields.benefitType7 || this.formData.benefit.type === this.formLabels.fields.benefitType8)
                || (this.formData.benefit.action === this.formLabels.fields.benefitAction2 && this.formData.benefit.amendAction && this.formData.benefit.amendAction !== "Keep current family members")
        },
        showPartnerFields() {
            return (this.formData.benefit.type === this.formLabels.fields.benefitType2 || this.formData.benefit.type === this.formLabels.fields.benefitType6) 
                && ((this.formData.benefit.amendAction && this.formData.benefit.action === this.formLabels.fields.benefitAction2) || (this.formData.benefit.action === this.formLabels.fields.benefitAction1))
        },
        benefitFields() {
            return this.formSummary[1].fields;
        },
        addFamilyButtonText() {
            return this.formData.benefit.amendAction && this.formData.benefit.amendAction === 'Remove family members' ? 'Remove another' : 'Add another';
        }
    },
    methods: {
        setConditionals() {
            // We need to store the full object paths for use in the core form
            this.formConditionals.benefitType = function() { return this.formData.benefit.action && this.formData.benefit.action === this.formLabels.benefit.fields.benefitAction1 };
            this.formConditionals.familyFields = function() { return (this.formData.benefit.type && this.formData.benefit.type !== this.formLabels.benefit.fields.benefitType1 && this.formData.benefit.type !== this.formLabels.benefit.fields.benefitType5) 
                || (this.formData.benefit.amendAction && this.formData.benefit.amendAction !== "Keep current family members") };
            this.formConditionals.amendAction = function() { return this.formData.benefit.action && this.formData.benefit.action === this.formLabels.benefit.fields.benefitAction2 };
        },
        buildSummary(fieldData) {
            let prettyLabels = {
                    action: 'Cover action',
                    type: 'Cover type',
                    amendAction: 'Amend action'
                };

            this.formSummary[1].title = this.formLabels.title;

            for(let key of Object.keys(fieldData)) {
                let label = this.formLabels[key];

                if(label) {
                    this.benefitFields[label] = fieldData[key];
                } else if(prettyLabels[key]) {
                    this.benefitFields[prettyLabels[key]] = fieldData[key];
                }
            }

            // Build the family data summary if data is present
            if(Object.keys(this.formData.familyMembers[0])) {
                for(let [mKey,member] of this.formData.familyMembers.entries()) {
                    for(let mfKey of Object.keys(member)) {
                        let label = this.formLabels['personFields'][mfKey];

                        if(label) {
                            this.benefitFields['Family members'][mKey][label] = member[mfKey];
                        }
                    }
                }
            }
        },
        addFamilyMember() {
            if(this.formData.benefit.type === this.formLabels.fields.benefitType4) {
                this.formData.familyMembers.push({ relationship: 'Child' });
            } else {
                this.formData.familyMembers.push({});
            }

            this.formSummary[1].fields['Family members'].push({});
        },
        removeFamilyMember(i) {
            let realIndex = i - 1,
                familySummary = this.formSummary[1].fields['Family members'];

            this.formData.familyMembers.splice(realIndex,1);
            familySummary.splice(realIndex,1);
        }
    },
    mounted() {
        this.setConditionals();

        this.formSummary.push({
            fields: {
                'Family members': [{}]
            }
        });
    }
}
</script>